import { Component, OnInit, OnDestroy } from '@angular/core';
import  { Router } from '@angular/router'

import { HomeService } from '../../service/home.service';
import { UserStoreService } from '../../service/user-store.service';
import { NavigateService } from '../../service/navigate.service';
import { ThemableBrowserService } from '../../service/themeable-browser.service';
import { list } from '../../../assets/js/bannerConfig.js'
@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.styl']
})
export class BannerComponent implements OnInit, OnDestroy {
    notice: string;
    spead: number;
    isShowNotice: boolean = false;
    bannerList: BannerModel[] = [];
    swiper: any;

    constructor(
        private homeService: HomeService,
        private userStoreService: UserStoreService,
        private themableBrowserService: ThemableBrowserService,
        private navigateService: NavigateService,
        private router: Router
    ){}

    ngOnInit() {
        // this.initNotice();
        this.getBannerList();
    }

    ngOnDestroy() {
        if (this.swiper) this.swiper.destroy();
    }

    //banner列表;
    getBannerList(){
        // let list = [
        //     // {
        //     //     url: '../../assets/img/banner_0227.png', 
        //     //     href: '/candidate/vote',
        //     //     outsideLink: false,
        //     //     queryData:'vote'
        //     // }
        //     {
        //         url: '../../assets/img/home-banner022.png', 
        //         href: '/person/person-info',
        //         outsideLink: false,
        //         queryData:'isRenew'
        //     }
        //     // { 
        //     //     url: '../../assets/img/home_banner_03.png',
        //     //     href: 'https://chinaicac.mikecrm.com/Je9OKWY',
        //     //     outsideLink: true
        //     // }
        //     // {
        //     //     url:'../../assets/img/bg-top1_0205.png',
        //     //     href: '/news/news-COVID-19'
        //     // },
        //     // {
        //     //     url:'../../assets/img/bg-top2.png',
        //     //     href: './events/national-Conference/detail/47'
        //     // }
        // ];

        list.forEach(value => {
            this.bannerList.push(new BannerModel(value.url, value.href, value.outsideLink, value.queryData));
        });
        setTimeout(() => this.initSwiper(), 0);
    }

    //初始化swiper;
    initSwiper() {
        const base = this;
        // this.swiper = new Swiper('.swiper-container', {
        //     autoplay: (base.bannerList.length > 1) ? 3000 : 0,
        //     loop: true,
        //     pagination: '.swiper-pagination',
        //     autoplayDisableOnInteraction: false
        // });
    }

    //banner点击事件;
    touchBanner(e){
        const target = e.target;
        if (target && target.dataset) {
            const url = target.dataset.url;
            const isOut = target.dataset.outside; 
            const queryData = target.dataset.querydata; 
            if (url){ 
                if (isOut == 'true') { 
                    window.open(url);
                } else if (queryData) {  
                    // console.log( 'queryData',queryData)
                    this.router.navigate([url],{ queryParams: {data:queryData} })
                    // this.navigateService.pushToRoute(url,queryData); 
                } else {
                    this.navigateService.pushToRoute(url); 
                }
            }
        }
    }

    //页面跳转;
    goPage(url) {
        this.navigateService.pushToRoute(url,);
    }

    // initNotice() {
    //   const showNotice = sessionStorage.getItem('isShowNotice');
    //   if (showNotice && !JSON.parse(showNotice)) return;
    //   this.isShowNotice = true;
    //   this.getNotice();
    // }

    // getNotice() {
    //   this.homeService.getNoticeList().subscribe(res => {
    //     if (res && res.length) {
    //       this.notice = res[0].content;
    //       this.spead = this.notice.length > 24 ? Math.ceil(this.notice.length / 3) : 8;
    //     }
    //   });
    // }

    // closeNotice() {
    //   this.isShowNotice = false;
    //   sessionStorage.setItem('isShowNotice', JSON.stringify(this.isShowNotice));
    // }
}

export class BannerModel {
    constructor(
        public imgUrl?: string,
        public targetUrl?: string,
        public outsideLink?: boolean,
        public queryData?: string,
    ){}
}


// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/home/banner/banner.component.ts